import { StackFrameMapper } from '../../../common/calls/mappers/StackFrameMapper';
import { DateUtils } from '../../../common/utils/DateUtils';
import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { OperationDetail } from '../models/OperationDetail';

export class OperationDetailMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();
  private readonly stackframeMapper = new StackFrameMapper();

  mapGQLModel(data: any): OperationDetail {
    const id = this.gqlIdEncoder.decode(data.id);
    const {
      id: reportEncodedId,
      traceType,
      project: { id: projectEncodedId },
    } = data.report;
    const reportId = this.gqlIdEncoder.decode(reportEncodedId);
    const projectId = this.gqlIdEncoder.decode(projectEncodedId);
    const valueJson = JSON.parse(data.valueJson);
    const timestamp = data.timestamp ? DateUtils.toMoment(data.timestamp) : null;
    const firstCallSite = data.firstCallSite ? this.stackframeMapper.mapGQLModel(data.firstCallSite, 0) : null;

    return new OperationDetail(id, reportId, projectId, traceType, data.type, data.context, data.algorithms, valueJson, firstCallSite, timestamp);
  }
}
